function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.938 9H7V.062A8 8 0 0115.938 9zm-2.021-2A6.005 6.005 0 009 2.083V7h4.917zM5 2.803V.582A8.003 8.003 0 008 16a8.003 8.003 0 007.418-5h-2.22A6 6 0 115 2.803z",
  fill: "#243143"
});

function SvgMarketingO16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45MzgxIDlIN1YwLjA2MTg5MzhDNy4zMjc1OSAwLjAyMTA0MzMgNy42NjEzNCAwIDggMEMxMi40MTgzIDAgMTYgMy41ODE3MiAxNiA4QzE2IDguMzM4NjYgMTUuOTc5IDguNjcyNDEgMTUuOTM4MSA5Wk0xMy45MTcgN0MxMy40OTU1IDQuNDg3NSAxMS41MTI1IDIuNTA0NDggOSAyLjA4Mjk2VjdIMTMuOTE3Wk01IDIuODAyNjlWMC41ODE1MTZDMi4wNjgxNyAxLjc2ODI5IDAgNC42NDI2MiAwIDhDMCAxMi40MTgzIDMuNTgxNzIgMTYgOCAxNkMxMS4zNTc0IDE2IDE0LjIzMTcgMTMuOTMxOCAxNS40MTg1IDExSDEzLjE5NzNDMTIuMTU5OSAxMi43OTM0IDEwLjIyMDggMTQgOCAxNEM0LjY4NjI5IDE0IDIgMTEuMzEzNyAyIDhDMiA1Ljc3OTE1IDMuMjA2NiAzLjg0MDEyIDUgMi44MDI2OVoiIGZpbGw9IiMyNDMxNDMiLz4KPC9zdmc+Cg==";
export { SvgMarketingO16 as ReactComponent };